import React from 'react';

export default function Footer() {
  return (
    <section id="contact" className="py-16 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-4xl font-bold mb-10">Get In Touch</h2>
        <h1 className='text-center text-lg font-semibold mb-10'>Contact us today and we'll get back to you soon.</h1>
        <div className="flex flex-col md:flex-row justify-between items-start">
          {/* Phone number aligned to the left on larger screens */}
          <div className="mb-6 md:mb-0 md:text-left">
            <p className="text-lg font-semibold">📞 Phone: <a className="text-[#fded22] hover:text-yellow-400 transition">8885001113</a></p>
          </div>
          
          {/* Location aligned to the right on larger screens */}
          <div className="flex items-start gap-2 mb-6 md:mb-0 md:text-right">
            <p className="text-lg font-semibold">📍 Location: </p>
            <div className='text-left mt-1'>
                  <p>Thotavari street</p>
                  <p>Nandamuri Nagar,</p>
                  <p>Vijayawada,</p>
                  <p>520015</p>
                  <a href="https://www.google.com/maps/place/KLIMKAARA+Fitness+center+GYM+AND+YOGA+CENTRE/@16.5448423,80.6362537,17z/data=!3m1!4b1!4m6!3m5!1s0x3a35e5e9251da89d:0x418b379bb4c4ac9d!8m2!3d16.5448423!4d80.6362537!16s%2Fg%2F11vx71f5st?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="text-[#fded22] hover:text-yellow-400 transition">

                  <p>Click here</p>
                </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
